const PCIcon = () => {
    return (
        <svg width="21" height="16" viewBox="0 0 21 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M3.49989 1.88235H17.4999V11.2941H3.49989V1.88235ZM1.49989 1.88235C1.49989 0.842755 2.39532 0 3.49989 0H17.4999C18.6045 0 19.4999 0.842755 19.4999 1.88235V13.1764H1.49989V1.88235ZM1.5 14.1177C0.947715 14.1177 0.5 14.539 0.5 15.0588C0.5 15.5786 0.947715 16 1.5 16H19.5C20.0523 16 20.5 15.5786 20.5 15.0588C20.5 14.539 20.0523 14.1177 19.5 14.1177H1.5Z" fill="white"/>
        </svg>
    );
}

export default PCIcon;